import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type DeleteMultiCartResponse = paths['/api/carts/multi-carts/{multiCartId}']['delete']['responses']['204']['content']['application/json']

export function deleteMultiCart(multiCartId: string) {
  return request.delete<DeleteMultiCartResponse>(`/api/carts/multi-carts/${multiCartId}`, { credentials: 'include' })
}
